import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-pdf",
  "use": "fileType-pdf-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"fileType-pdf\"><defs><symbol id=\"fileType-pdf_file-pdf\" data-name=\"file-pdf\" viewBox=\"0 0 20 20\"><path d=\"M15.77,0H0V20H20V4.23ZM5,10.89H3.43v2.34H2.51v-6H5c1.43,0,2.15.61,2.15,1.83S6.43,10.89,5,10.89Zm7.18,1.53a2.87,2.87,0,0,1-2.21.81H7.79v-6H10A2.85,2.85,0,0,1,12.19,8a3.1,3.1,0,0,1,.71,2.19A3.13,3.13,0,0,1,12.17,12.42ZM17.7,8H14.54V9.75h3v.78h-3v2.69h-.92v-6H17.7ZM15.77,4.37V.28l4.08,4.08ZM4.93,8H3.43V10.1h1.5a1.58,1.58,0,0,0,1-.25A1,1,0,0,0,6.23,9a.92.92,0,0,0-.32-.79A1.57,1.57,0,0,0,4.93,8ZM9.81,8H8.71v4.45H9.8a2.27,2.27,0,0,0,1.68-.55A2.35,2.35,0,0,0,12,10.22a2.37,2.37,0,0,0-.51-1.68A2.24,2.24,0,0,0,9.81,8Z\" fill=\"#ef5a3c\" /></symbol></defs><title>pdf</title><g id=\"fileType-pdf_图层_2\" data-name=\"图层 2\"><g id=\"fileType-pdf_图层_1-2\" data-name=\"图层 1\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-pdf_file-pdf\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-pdf.svg
// module id = 28+Z
// module chunks = 264